import { VBTooltip } from './tooltip';
import { pluginFactory } from '../../utils/plugins';
var VBTooltipPlugin =
/*#__PURE__*/
pluginFactory({
  directives: {
    VBTooltip: VBTooltip
  }
});
export { VBTooltipPlugin, VBTooltip };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/directives/tooltip/index.js
// module id = ./node_modules/bootstrap-vue/esm/directives/tooltip/index.js
// module chunks = 1